<template>
    <v-layout row wrap align-center :class="isMobile ? 'ml-20' : 'ml-100'">
        <v-flex xs6 sm4>
            <div class="caption grey--text">Employment Status</div>
            <b :class="commonfn.getStatusColor(employment_info.employmentStatus)">
                {{commonfn.getStatusDescription(employment_info.employmentStatus)}}
            </b>
        </v-flex>
        
        <v-flex xs6 sm4>
            <div class="caption grey--text">Employment Type</div>
            <div>{{commonfn.getStatusDescription(employment_info.employmentType)}}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">Work Arrangement</div>
            <div>{{ employment_info.workArrangement ? commonfn.getStatusDescription(employment_info.workArrangement) : '—' }}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">Role Category</div>
            <div>{{ employment_info.roleCategory ? commonfn.getStatusDescription(employment_info.roleCategory) : '—' }}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">Position</div>
            <div>{{employment_info.position}}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">Start Date</div>
            <div>{{employment_info.startDate | moment('MMM DD, YYYY')}}</div>
        </v-flex>

        <v-flex v-if="isResignedOrTerminated" xs6 sm4>
            <div class="caption grey--text">Last Working Date</div>
            <div>{{employment_info.endDate | moment('MMM DD, YYYY')}}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">Salary Type</div>
            <div>{{ employment_info.salaryType ? commonfn.getSalaryTypeName(employment_info.salaryType) : '—' }}</div>
        </v-flex>
        
        <v-flex xs6 sm4>
            <div class="caption grey--text">Work Email</div>
            <div class="wrapped-filename">{{ employment_info.workEmail || '—' }}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">TIN</div>
            <div class="body-2 font-weight-medium">{{formattedTIN || '—'}}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">SSS Number</div>
            <div class="body-2 font-weight-medium">{{formattedSSS || '—'}}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">Pag-IBIG Number</div>
            <div class="body-2 font-weight-medium">{{formattedPagibig || '—'}}</div>
        </v-flex>

        <v-flex xs6 sm4>
            <div class="caption grey--text">PhilHealth Number</div>
            <div class="body-2 font-weight-medium">{{formattedPhilhealth || '—'}}</div>
        </v-flex>
    </v-layout>
</template>


<script>

import commonfn from '@/common/functions' //for refactor

export default {
    components: {},
    data() {
        return {
            commonfn,
        }
    },
    props: ['employment_info'],
    computed: {
        isResignedOrTerminated() {
            return this.employment_info.employmentStatus==commonfn.getStatusCode('Resigned') ||
                    this.employment_info.employmentStatus==commonfn.getStatusCode('Terminated')
        },
        formattedTIN() {
            if (this.employment_info.tin)
                return `${this.employment_info.tin.substring(0,3)}-${this.employment_info.tin.substring(3,6)}-${this.employment_info.tin.substring(6,9)}`
        },
        formattedSSS() {
            if (this.employment_info.sss)
                return `${this.employment_info.sss.substring(0,2)}-${this.employment_info.sss.substring(2,9)}-${this.employment_info.sss.substring(9,10)}`
        },
        formattedPagibig() {
            if (this.employment_info.pagibig)
                return `${this.employment_info.pagibig.substring(0,4)}-${this.employment_info.pagibig.substring(4,8)}-${this.employment_info.pagibig.substring(8,12)}`
        },
        formattedPhilhealth() {
            if (this.employment_info.philhealth)
                return `${this.employment_info.philhealth.substring(0,2)}-${this.employment_info.philhealth.substring(2,11)}-${this.employment_info.philhealth.substring(11,12)}`
        },
    },
}
</script>
<style scoped>
.section-layout {
    padding:0px 20px 0px 100px;
}
.section-layout-mobile {
    padding:0px 10px 0px 10px;
}
</style>